import { render, staticRenderFns } from "./ExternalDeliveryServiceForm.vue?vue&type=template&id=52b199b2"
import script from "./ExternalDeliveryServiceForm.vue?vue&type=script&lang=ts"
export * from "./ExternalDeliveryServiceForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports